import React from 'react';
const SvgPpsxThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M68.001 6H24v8H8v2h2v36h16v6h-6v2h6v6L16 76v4l8-8v18h4v-2h6v2h54V26z" />
      <path fill="#949494" d="M88 26L68.001 6H24v8h2V8h40v20h20v60H34v2h54V26zm-20 0V9l17 17H68z" />
      <path fill="#FFF" d="M11 15h46v36H11z" />
      <path fill="gray" d="M56 16v34H12V16h44m2-2H10v38h48V14z" />
      <path fill="gray" d="M8 14h52v2H8zM32 50h2v10h-2z" />
      <path fill="#C8C8C8" d="M16 22h4v22h-4z" />
      <path fill="#F5BA9D" d="M24 26h4v18h-4z" />
      <path fill="#C8C8C8" d="M32 30h4v14h-4z" />
      <path fill="#F5BA9D" d="M40 34h4v10h-4z" />
      <path fill="#C8C8C8" d="M48 38h4v6h-4z" />
      <path fill="#D04727" d="M36 76L26 66 16 76v4l8-8v18h4V72l8 8z" />
      <path fill="gray" d="M20 58h26v2H20z" />
      <linearGradient id="ppsx-thumbnail_svg__a" gradientUnits="userSpaceOnUse" x1={76} y1={33.813} x2={76} y2={28.175}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ppsx-thumbnail_svg__a)" d="M66 28h20v6H66z" />
      <linearGradient
        id="ppsx-thumbnail_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={62.54}
        y1={24.46}
        x2={74.472}
        y2={12.528}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#ppsx-thumbnail_svg__b)" d="M24 6v2h42v20h20v28h2V26L68 6z" />
      <linearGradient
        id="ppsx-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={16.401}
        y1={7.436}
        x2={83.596}
        y2={93.441}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path
        fill="url(#ppsx-thumbnail_svg__c)"
        d="M68.001 6H24v8H8v2h2v36h16v6h-6v2h6v6L16 76v4l8-8v18h4v-2h6v2h54V26z"
      />
    </svg>
  );
});
export default SvgPpsxThumbnail;
SvgPpsxThumbnail.iconName = 'ppsx-thumbnail';
SvgPpsxThumbnail.displayName = 'SvgPpsxThumbnail';
